import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CircleNotch, SealCheck, WarningCircle } from "@phosphor-icons/react";
import { API, formatApiError } from "../lib/api";
import { DispatchSlip } from "../components/dispatch/DispatchSlip";

export default function PublicDispatch() {
  const { token } = useParams();
  const [slip, setSlip] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/public/dispatch/${token}`).then((r) => setSlip(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-100 px-3 sm:px-6 py-6 sm:py-10" data-testid="public-dispatch-page">
      <div className="max-w-[860px] mx-auto space-y-4">
        {slip && (
          <div className="rounded-xl bg-emerald-600 text-white px-4 py-3 flex items-center gap-2 text-sm font-semibold shadow-lg shadow-emerald-600/20" data-testid="public-verified-banner">
            <SealCheck size={20} weight="fill" /> Verified dispatch record · Anuj Solar
          </div>
        )}
        {err ? (
          <div className="rounded-xl bg-white p-10 text-center text-rose-600 flex flex-col items-center gap-2" data-testid="public-dispatch-error"><WarningCircle size={32} /> {err}</div>
        ) : slip ? <DispatchSlip slip={slip} /> : (
          <div className="py-24 flex justify-center"><CircleNotch size={32} className="animate-spin text-slate-400" /></div>
        )}
      </div>
    </div>
  );
}
